import { render, staticRenderFns } from "./ParentControlIssueForm.vue?vue&type=template&id=c9201b16&scoped=true&"
import script from "./ParentControlIssueForm.vue?vue&type=script&lang=js&"
export * from "./ParentControlIssueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9201b16",
  null
  
)

export default component.exports